import React from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";

export const LegacyDestination = ({ kind }) => {
  const location = useLocation(); const params = useParams();
  const query = new URLSearchParams(location.search);
  let path = "/today";
  if (query.get("focus")) return <Navigate replace to={`/briefs/${encodeURIComponent(query.get("focus"))}`} />;
  if (kind === "archive") query.set("view", "archive");
  if (kind === "reader") { query.set("mode", "reader"); if (!query.has("view")) query.set("view", "archive"); }
  if (kind === "world" || kind === "countries" || kind === "topics") { path = "/explore"; query.set("view", kind === "world" ? "map" : kind); }
  if (kind === "arc") { path = `/topics/${params.slug}`; query.set("tab", "timeline"); }
  if (kind === "story") path = `/briefs/${params.id}`;
  return <Navigate replace to={`${path}${query.size ? `?${query}` : ""}`} state={location.state} />;
};